import { render, staticRenderFns } from "./newLabel.vue?vue&type=template&id=93d7f864&scoped=true&"
import script from "./newLabel.vue?vue&type=script&lang=js&"
export * from "./newLabel.vue?vue&type=script&lang=js&"
import style0 from "./newLabel.vue?vue&type=style&index=0&id=93d7f864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d7f864",
  null
  
)

export default component.exports